import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Observable } from 'rxjs';
import { routePaths } from '@constants/index';
import { SessionService } from './session.service';

@Injectable()
export class AdminAuthGuardService implements CanActivate {

  constructor(private sessionService: SessionService, private router: Router) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    if (this.sessionService.isAuthenticate()) {
      if (!this.sessionService.isAdmin()) {
        this.router.navigateByUrl(routePaths.dashboard);
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }
}
